export default {
  deleteButton: {
    id: 'profile_page_legal_documents_tab_delete_button_aria_label',
    defaultMessage: 'Delete document',
  },
  downloadButton: {
    id: 'profile_page_legal_documents_tab_download_button_aria_label',
    defaultMessage: 'Download document',
  },
  emptyLegalDocument: {
    id: 'profile_page_legal_documents_tab_empty_legal_detail',
    defaultMessage: 'Take a second to add this information.',
  },
  toastErrorContent: {
    id: 'profile_page_delete_document_toast_error_generic_content',
    defaultMessage: 'We are sorry, something went wrong!',
  },
  toastDeleteSuccessContent: {
    id: 'profile_page_delete_document_toast_succcess_content',
    defaultMessage: 'Document deleted ✔️',
  },
}
